import { ReactElement } from 'react';
import { validateCharactersLimit } from '@client/common/utils/form/validateCharactersLimit';
import { emailRule } from '@client/common/utils/validations/validationRules';
import { useTranslate } from '@client/i18n/hooks';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Body } from './Body';
import { Props } from './Form.types';
import { FIELD_NAME } from './FormContainer.types';

export const Form = (props: Props): ReactElement => {
  const t = useTranslate();
  const {
    defaultEmail,
    onSubmit,
  } = props;
  const validationSchema = (): Record<string, any> => yup.object().shape({
    [FIELD_NAME.email]: emailRule({
      errorEmailFormat: t('Email is not valid'),
      errorEmailRequired: t('Required'),
    }).test(validateCharactersLimit(76, t)),
  });

  return (
    <Formik
      initialValues={{
        [FIELD_NAME.email]: defaultEmail,
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Body {...props} />
    </Formik>
  );
};
